import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import MockPagination from "./Pagination";
import ReportCard from "./ReportCard";

// Fetching Data from the API]

// End

// Page Html
export default function ResultPage() {
  // End

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <div className="relative top-24 md:left-[290px] bg-gray-100 max-w-6xl py-5 px-5 md:px-10 mx-4 rounded-sm">
        <ReportCard/>
      </div>
    </div>
  );
}
